import { VehicleDetail } from 'chariot/types';
import ProjectDetails, { ExtendedProjectDetails } from './projectDetails';
import Staff from './staff';

export enum BEJobStatus {
  Prebooked = 'PREBOOKED',
  Created = 'CREATED',
  PickAssigned = 'PICK_ASSIGNED',
  PickAccepted = 'PICK_ACCEPTED',
  PickPicked = 'START_PICKUP',
  PickParked = 'PARKED',
  PickKeySubmitted = 'PICKUP_KEY_SUBMITTED',
  DropRequest = 'RECALLED',
  DropAssigned = 'DROP_ASSIGNED',
  DropAccepted = 'ACCEPTED_DROP',
  DropPicked = 'START_DROP',
  DropKeyReturned = 'DROP_KEY_RETURNED',
  DropDelivered = 'DELIVERED',
  Rated = 'RATED',
  Tipped = 'TIPPED',
  Cancelled = 'CANCELLED',
  DropReturned = 'RETURNED',
}

export enum BusinessType {
  Valet = 'valet',
  Dealer = 'dealer',
}

export type Timeline = {
  title: string;
  content: string;
  time: string;
  carImages?: string[];
  isPaid?: boolean;
};

export type BookingDetails = {
  bookingId: string;
  vehicleDetails: VehicleDetail;
  projectDetails: ProjectDetails;
  bookingDate: string;
  bookingStatus: BEJobStatus;
};

export type StaticBookingDetails = {
  prebookingSelectedDate: string;
  isPrebooking: boolean;
  createdAt: string;
  projectDetails: ExtendedProjectDetails;
  tagId: number;
  tagSequence: number;
  isSaas: boolean;
  pickValetDetails: Staff;
  dropValetDetails: Staff;
  supervisorDetails: Staff;
  vehicleDetails?: VehicleDetail;
  isCashOnly: boolean;
  isInsuranceAllowed: boolean;
  deliveryCode?: number;
  businessType?: BusinessType;
  prebookCode?: number;
  isTippingAllowed: boolean;
  isPrebookingAllowed: boolean;
  userBookingCount: number;
};

export type DynamicBookingDetails = {
  bookingId: number;
  status: BEJobStatus;
  isPaid: boolean;
  bookingAmount: number;
  arrivingIn: number;
  lastArrival: number;
  timeline: Timeline[];
  pickupAssignedTime: string;
  pickupAcceptTime: string;
  parkedTime: string;
  dropCalledTime: string;
  dropAcceptTime: string;
  droppedTime: string;
  isInsuranceAvailed: boolean;
  queueNumber: number;
  pocDetails: PocDetails;
};

type PocDetails = {
  name: string;
  phoneNumber: string;
  emailId: string;
};

export type ReferralCode = {
  code: string;
};
